import { Configuration2D } from '../../configuration2d';
import { Resume } from './resume';
import { CarpentryLocation } from './carpentry-location';
import { QuotationRecord } from './quotation-record';
import { ConfigurationAssistance } from './assistance/configuration-assistance';

export class Configuration extends Configuration2D {
  /**
   * Carpentry Configuration
   */
  location: CarpentryLocation;
  quotationRecords: QuotationRecord[];
  assistances: ConfigurationAssistance[];
  installationReminder: boolean;
  configurationHasChanged?: boolean;
  isLocked?: boolean;
  _resume: Resume;

  get resume() {
    return this._resume;
  }

  override set resume(resume: Resume) {
    this._resume = resume;
  }
}
